import { deleteCookie } from 'cookies-next/client';
import type { CookieStorageItems } from '@/core/models/cookie-storage';
import { ClientCookies } from '@/core/services/cookie-storage';
import { clearFreshOrderId } from '@/core/utils/clear-checkout-market-session';

const STALE_CART_COOKIE_NAMES = [
  'orderId',
  'adyenSession',
  'cartItemsCount',
] as const satisfies ReadonlyArray<keyof CookieStorageItems>;

/** Clears persisted cart identity when the BFF reports the cart is invalid (client-only). */
export default async function invalidateStaleShoppingCart(): Promise<void> {
  if (typeof window === 'undefined') return;

  clearFreshOrderId();

  for (const name of STALE_CART_COOKIE_NAMES) {
    deleteCookie(name);
    void ClientCookies.remove(name);
    document.cookie = `${name}=; Max-Age=0; path=/`;
    document.cookie = `${name}=; Max-Age=0; path=/; domain=${window.location.hostname}`;
  }
}
